import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';

const iconBtnDefaultStyle = {
  "extra-small": {
    width: 18,
    height: 18,
  },
  small: {
    width: 24,
    height: 24,
  },
  medium: {
    width: 32,
    height: 32,
  },
  large: {
    width: 40,
    height: 40,
  },
};
const iconDefaultStyle = {
  "extra-small": {
    width: 12,
    height: 12,
  },
  small: {
    width: 16,
    height: 16,
  },
};

export const EditIconButton = (props) => {
  const { className, size, onClick } = props;
  const btnSize = size === "extra-small" ? "small" : size;
  const btnStyle = iconBtnDefaultStyle[size] || {};
  const innerStyle = iconDefaultStyle[size] || {};
  return (
    <IconButton variant="outlined" className={clsx(className)} onClick={onClick}
      size={btnSize}
      style={{ border: "1px solid rgba(0, 0, 0, 0.54)", ...btnStyle }}>
      <EditIcon style={{ ...innerStyle }} />
    </IconButton>
  )
}

export default EditIconButton